






import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class AddButton extends Vue {
    @Prop() public btnAddText: string;
    @Prop() public action: string;

    get kebabText() {
        return this.btnAddText.replace(/([a-z])([A-Z])/g, '$1-$2').replace(/\s+/g, '-').toLowerCase();
    }

    constructor() {
        super();
    }
}
